<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="regions"
            outlined
            autocomplete
        ></v-autocomplete>

        <h5>{{country}}</h5>
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>

</template>

<script>
    /**
     * Allows the selection of an editorial region ID by choosing its name from
     * a selection downloaded from the API on creation
     */
    export default {
        name: 'ies-region-key',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                regions: [],
				country: '',
                viewValue: parseInt(this.field.value),
            }
        },
        created:function() {
            this.getRegions();
			this.setCountry();
        },

        methods: {
            getRegions:function(){
                axios.get('/api/selectable-regions')
                .then(function(response){
                    var regions = [];
                    response.data.regions.forEach(function(record){
                        regions.push({ text: record.region_name, value: record.region_key });
                    });
                    this.regions = regions;
                }.bind(this));
            },
			setCountry:function(){
				if (this.field.value) {
					console.log('Region key:', this.field.value);
					axios.get('/api/get-country-from-region/' + this.field.value).then((response) => {
						this.country = response.data.country.region_name;
					});
				} else {
					this.country = '';
				}
			},
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
				this.setCountry();
            }
        }
    }
</script>
